import type { IconData } from '@stacksjs/iconify-core'

export const internetNetworkLaptop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17.525 28.95h13.71v1.53h-13.71Zm7.62-15.24h1.52v3.05h-1.52Zm-7.62-7.62h1.52v1.53h-1.52Zm-4.57 24.39h4.57V32h-4.57Zm4.57-1.53v-1.52h-1.52v-4.57h10.66v-1.53h1.53v-4.57h-1.53v3.05H3.815v-3.05h-1.53v4.57h1.53v1.53h10.66v4.57h-1.52v1.52z\"/><path fill=\"currentColor\" d=\"M12.955 16.76h4.57v1.52h-4.57Zm1.52-10.67h1.53v1.53h-1.53ZM.765 28.95h12.19v1.53H.765Zm10.66-22.86h1.53v1.53h-1.53ZM6.855 0h16.76v1.52H6.855Z\"/><path fill=\"currentColor\" d=\"M25.145 13.71V1.52h-1.53v10.67H6.855V1.52h-1.52v12.19zm-21.33 0h1.52v3.05h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default internetNetworkLaptop
